import { useDispatch } from 'react-redux';

import { NsCard } from 'components/common/ns-card/NsCard';
import { psrConfig } from 'config/psr-config';
import {
  setPsrExpiryDate,
  setPsrPreferences,
  setPsrSubCode
} from 'state/psr/psr-slice';
import { PsrInput } from './PsrInput';
import { PsrExpiryDate } from './PsrExpiryDate';
import NsContent from 'components/common/ns-content/NsContent';

export const PsrList = () => {
  const dispatch = useDispatch();

  const handleSelectPsr = (event) => {
    const { value, name } = event.target;
    const checked = !!value;
    const [type, code, subCode] = name.split('-');

    dispatch(setPsrPreferences({ type, psrItem: { code, subCode }, checked }));
  };

  const handleSelectSubcode = (event) => {
    const { name } = event.target;
    const [type, code] = name.split('-');
    const subCode = event.target.value;

    dispatch(setPsrSubCode({ type, psrItem: { code, subCode } }));
  };

  const handleChangeExpiryDate = (event) => {
    const {
      target: { processedValue: value, name }
    } = event;
    const [type, code, subCode] = name.split('-');

    dispatch(setPsrExpiryDate({ code, subCode, type, expiryDate: value }));
  };

  return (
    <>
      <h3>Please select every option that applies to your household</h3>
      {psrConfig?.map((section) => {
        const { displayName, codes } = section;

        return (
          <NsCard key={displayName?.replace(/\s/, '-')} heading={displayName}>
            <NsContent>
              <div>
                {codes.map((psrItem) => (
                  <PsrInput
                    key={JSON.stringify(psrItem)}
                    psrItem={psrItem}
                    handleSelectPsr={handleSelectPsr}
                    handleSelectSubcode={handleSelectSubcode}
                  />
                ))}
              </div>
              {codes.map((psrItem) => (
                <PsrExpiryDate
                  key={JSON.stringify(psrItem)}
                  psrItem={psrItem}
                  handleChange={handleChangeExpiryDate}
                />
              ))}
            </NsContent>
          </NsCard>
        );
      })}
    </>
  );
};
